import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from './baseQuery'

/**
 * *Documentation: https://redux-toolkit.js.org/rtk-query/overview
 */
export const laravel_api = createApi({
    reducerPath: 'laravel_api',
    baseQuery: baseQuery(),
    tagTypes: [
        'Maintenances',
        'Campaigns',
        'CampaignForecasts',
        'SocialMediaProfiles',
        'XAdsAccounts',
        'XAdsFundingInstruments',
        'GoogleAdsAudiences',
        'MetaAdsPages',
        'AuditRecords',
        'LegalAcceptances',
        'LegalTermVersions'
    ],
    endpoints: (builder) => ({})
})
